import React from "react"
import { Box } from "theme-ui"

const EmptyCell = (): JSX.Element => {
  return <Box sx={{ display: ["none", null, null, "block"] }} />
}

export default EmptyCell
